/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { rangeDependencies } from './dependenciesRange.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createColumnTransform } from '../../factoriesAny.js';
export var columnTransformDependencies = {
  IndexDependencies,
  matrixDependencies,
  rangeDependencies,
  typedDependencies,
  createColumnTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesColumnTransform.generated.js
// module id = 1328
// module chunks = 2